/** 日期时间工具 */
import type { EventStatus, RegistrationStatus, UserRole, UserGroup, BindingStatus, PlayerType } from '@/api/enums'

const WEEK = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

export function fmtDateTime(v?: string | null): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '—'
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
}

export function fmtDate(v?: string | null): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '—'
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export function fmtShort(v?: string | null): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '—'
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
}

export function fmtRelative(v?: string | null): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '—'
  const diff = d.getTime() - Date.now()
  const abs = Math.abs(diff)
  const min = Math.round(abs / 60000)
  if (min < 1) return '刚刚'
  if (min < 60) return `${min} 分钟${diff > 0 ? '后' : '前'}`
  const hr = Math.round(min / 60)
  if (hr < 24) return `${hr} 小时${diff > 0 ? '后' : '前'}`
  const day = Math.round(hr / 24)
  if (day < 30) return `${day} 天${diff > 0 ? '后' : '前'}`
  return fmtDate(v)
}

export function fmtWeekday(v?: string | null): string {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return '—'
  return WEEK[d.getDay()]
}

export function fmtMoney(n: number): string {
  return n.toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' })
}

// ============ 枚举显示名 ============

export const EVENT_STATUS_LABEL: Record<EventStatus, string> = {
  Draft: '草稿',
  RegistrationOpen: '报名中',
  RegistrationClosed: '报名结束',
  InProgress: '进行中',
  Completed: '已结束',
  Cancelled: '已取消',
}

export const REG_STATUS_LABEL: Record<RegistrationStatus, string> = {
  Pending: '待审核',
  Registered: '已报名',
  Confirmed: '已确认',
  Approved: '已批准',
  Cancelled: '已取消',
  Rejected: '已拒绝',
}

export const ROLE_LABEL: Record<UserRole, string> = {
  None: '无角色',
  User: '用户',
  Admin: '管理员',
  SuperAdmin: '超级管理员',
}

export const GROUP_LABEL: Record<UserGroup, string> = {
  Free: '免费用户',
  Standard: '标准订阅',
  Premium: '高级订阅',
}

export const BINDING_STATUS_LABEL: Record<BindingStatus, string> = {
  Pending: '待处理',
  Accepted: '已接受',
  Rejected: '已拒绝',
  Expired: '已过期',
  Cancelled: '已取消',
}

export const PLAYER_TYPE_LABEL: Record<PlayerType, string> = {
  Regulator: '监管者',
  Survivor: '求生者',
}
